import { getBrand } from '../../api';

export const SET_BRAND = 'SET_BRAND';

export const setBrand = (brand) => ({
  type: SET_BRAND,
  accentColor: brand?.accentColor ?? null,
  logoUrl: brand?.logoUrl ?? null
});

/**
 * Fetch the school's brand. Public, so it runs on the sign-in page too. A
 * server without brand routes has no brand, which is the SimulAlert default.
 */
export const loadBrand = (dispatch) => {
  getBrand()
    .then((brand) => dispatch(setBrand(brand)))
    .catch(() => {
      // Keep whatever was persisted; the dashboard works the same without it.
    });
};
